import { createContext } from 'react';

export interface IAuthUser {
    email?: string,
    first_name?: string,
    last_name?: string,
}

export interface IAuthContext {
    isAuth: boolean,
    setAuth: (value: boolean) => void,
    user: IAuthUser | null,
}

const initialContext = {
    isAuth: false,
    setAuth: () => {},
    user: null,
}

export const AuthContext = createContext<IAuthContext>(initialContext)
